module.exports = __webpack_public_path__ + "img/P26.899d7d45.png";